import { render, staticRenderFns } from "./appApprovals.vue?vue&type=template&id=3e75759f&scoped=true"
import script from "./appApprovals.vue?vue&type=script&lang=js"
export * from "./appApprovals.vue?vue&type=script&lang=js"
import style0 from "./appApprovals.vue?vue&type=style&index=0&id=3e75759f&prod&scoped=true&lang=scss"
import style1 from "./appApprovals.vue?vue&type=style&index=1&id=3e75759f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e75759f",
  null
  
)

export default component.exports